<ng-container *appFeatureToggle="'enableRequiredReading'">
    <section class="widget-section order-1">
        <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #reqReadContainer>
            <app-required-reading appMarkComponentVisited [appHideParentIfEmpty]="reqReadContainer"></app-required-reading>
        </div>
    </section>
</ng-container>
<section class="widget-section order-2">
    <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
        <div class="row">
            <div class="col">
                <cafcass-custom-find-information-mega-menu></cafcass-custom-find-information-mega-menu>
            </div>
            <ng-container *appFeatureToggle="'enableRightSection'">
                <div class="find-information-rightcol col-lg-4 col-xl-3">
                    <div>
                        <app-find-information-saved-pages></app-find-information-saved-pages>
                    </div>
                    <div>
                        <app-find-information-trending-pages></app-find-information-trending-pages>
                    </div>
                    <div class="mt-4" #infoBoxContainer>
                      <app-infobox-zone appMarkComponentVisited area="FindInformation" [appHideParentIfEmpty]="infoBoxContainer"></app-infobox-zone>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>
